import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsTranslateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-translate',
	path: '/secure/admin/TranslateCustomField!default.jspa',
};
